import * as Yup from 'yup'
import { imageInputSchema } from './common'
const platformChargeValidationSchema = Yup.object().shape({
  value: Yup.object().shape({
    doctorRate: Yup.number().required('Doctor rate is required'),
    clinicRate: Yup.number().required('Clinic rate is required'),
    pharmacyRate: Yup.number().required('Pharmacy rate is required'),
  }),
})

const supportValidationSchema = Yup.object().shape({
  value: Yup.object().shape({
    supportName: Yup.string().required('Support name is required'),
    phone: Yup.string().required('Phone no is required'),
    email: Yup.string().email().required('Email is required'),
    address: Yup.string().required('Address is required'),
    whatsapp: Yup.string().required('Whatapp is required'),
  }),
})

const downloadLinkValidationSchema = Yup.object().shape({
  value: Yup.object().shape({
    iosLink: Yup.string().url().required('Ios Link is required'),
    androidLink: Yup.string().url().required('Android Link is required'),
    isAndroidActive: Yup.boolean(),
    isIosActive: Yup.boolean(),
    version: Yup.string(),
  }),
})

const bannerValidationSchema = Yup.object().shape({
  value: Yup.object().shape({
    title: Yup.string().required('Title is required'),
    redirectLink: Yup.string().url(),
  }),
  file: imageInputSchema,
})

const seoValidationSchema = Yup.object({
  value: Yup.object().shape({
    metaTitle: Yup.string().required('Meta Title is required'),
    metaKeywords: Yup.string().required('Meta Keyword is required'),
    metaDescription: Yup.string().required('Meta Description is required'),
  }),
})

const faqValidationSchema = Yup.object({
  value: Yup.object().shape({
    category: Yup.string().required('Category in required'),
    question: Yup.string().required('Question is required'),
    answer: Yup.string().required('Answer is required'),
  }),
})

const healthAdviceValidationSchema = Yup.object({
  value: Yup.object().shape({
    category: Yup.string().required('Category is required'),
    title: Yup.string().required('Advice title is tequired'),
    description: Yup.string().required('Health advice is required'),
  }),
})

export default {
  platformChargeValidationSchema,
  supportValidationSchema,
  downloadLinkValidationSchema,
  bannerValidationSchema,
  seoValidationSchema,
  faqValidationSchema,
  healthAdviceValidationSchema,
}
